/* Optician carousel. Ported from wireOpticianCarousel() in
   serious-readers-brand-2026/public/home-opticians.js.

   One change: the spoken status line read the optician name from the render-time
   homeOpticians array. The cards are Liquid now, so it reads the name from the
   card itself. */
(function () {
  var opticianRailCleanup = null;

  function wireOpticianCarousel() {
    if (opticianRailCleanup) opticianRailCleanup();
    opticianRailCleanup = null;
    const section = document.querySelector('.home-opticians.optician-rail-section');
    if (!section) return;
    const track = section.querySelector('.optician-rail-track');
    const cards = Array.from(section.querySelectorAll('.optician-rail-card'));
    if (!track || !cards.length) return;
    const previous = section.querySelector('[data-optician-rail-prev]');
    const next = section.querySelector('[data-optician-rail-next]');
    const rotation = section.querySelector('[data-optician-rail-rotation]');
    const progress = section.querySelector('[data-optician-rail-progress]');
    const status = section.querySelector('[data-optician-rail-status]');
    let targets = [];
    let current = 0;
    let requested = null;
    let frame = 0;
    let settle = 0;
    let rotationTimer = 0;
    let disposed = false;
    let manualAnnouncement = false;
    let automaticMove = false;
    let pointerRotationIntent = null;
    let visible = false;
    let focused = section.contains(document.activeElement);
    let hovered = window.matchMedia('(hover: hover)').matches && section.matches(':hover');
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    // The house style has no carousel that moves by itself (23 Sep 2026); the arrows and a swipe still move it.
    let rotationEnabled = false;

    const maximum = () => Math.max(0, track.scrollWidth - track.clientWidth);
    const canRotate = () => !disposed && section.isConnected && rotationEnabled && !motion.matches &&
      visible && !document.hidden && !hovered && !focused && cards.length > 1 && maximum() > 2;
    const syncRotation = () => {
      clearTimeout(rotationTimer);
      rotationTimer = 0;
      const available = cards.length > 1 && maximum() > 2 && !motion.matches;
      rotation.disabled = !available;
      rotation.dataset.rotating = String(rotationEnabled && available);
      const label = motion.matches ? 'Automatic rotation disabled for reduced motion' :
        rotationEnabled && available ? 'Pause automatic rotation' : 'Start automatic rotation';
      rotation.setAttribute('aria-label', label);
      rotation.title = label;
      if (canRotate()) {
        rotationTimer = setTimeout(() => {
          rotationTimer = 0;
          if (!canRotate()) return;
          update();
          let destination = current + 1;
          while (destination < cards.length && targets[destination] <= track.scrollLeft + 2) destination++;
          goTo(destination < cards.length ? destination : 0, false);
          syncRotation();
        }, 10000);
      } else if (automaticMove) {
        automaticMove = false;
        requested = null;
        clearTimeout(settle);
        track.scrollTo({left: track.scrollLeft, behavior: 'auto'});
      }
    };
    const stopRotation = () => { rotationEnabled = false; syncRotation(); };
    const update = () => {
      const limit = maximum();
      const position = Math.max(0, Math.min(limit, track.scrollLeft));
      let nearest = 0;
      targets.forEach((target, index) => {
        if (Math.abs(target - position) < Math.abs(targets[nearest] - position)) nearest = index;
      });
      if (limit > 1 && position >= limit - 2) nearest = cards.length - 1;
      current = nearest;
      previous.disabled = position <= 2;
      next.disabled = limit <= 2 || position >= limit - 2;
      progress.style.transform = `scaleX(${limit <= 2 ? 1 : (current + 1) / cards.length})`;
    };
    const measure = () => {
      const start = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      const origin = track.getBoundingClientRect().left + track.clientLeft;
      const limit = maximum();
      targets = cards.map(card => Math.max(0, Math.min(limit, card.getBoundingClientRect().left - origin + track.scrollLeft - start)));
      update();
      if (!intersectionObserver) checkVisibility();
      else syncRotation();
    };
    const finishScroll = () => {
      if (disposed) return;
      requested = null;
      automaticMove = false;
      update();
      if (manualAnnouncement) status.textContent = `Recommendation ${current + 1} of ${cards.length}: ${(cards[current].querySelector('.optician-rail-person strong') || cards[current]).textContent.trim()}.`;
      manualAnnouncement = false;
    };
    const onScroll = () => {
      if (!frame) frame = requestAnimationFrame(() => { frame = 0; update(); });
      clearTimeout(settle);
      settle = setTimeout(finishScroll, 180);
    };
    const goTo = (index, manual = true) => {
      if (manual) stopRotation();
      requested = Math.max(0, Math.min(cards.length - 1, index));
      manualAnnouncement = manual;
      automaticMove = !manual;
      track.scrollTo({left: targets[requested], behavior: motion.matches ? 'auto' : 'smooth'});
      clearTimeout(settle);
      settle = setTimeout(finishScroll, motion.matches ? 40 : 700);
    };
    const goPrevious = () => {
      const origin = requested === null ? current : requested;
      let destination = origin - 1;
      while (destination > 0 && targets[destination] >= targets[origin] - 2) destination--;
      goTo(destination);
    };
    const goNext = () => {
      const origin = requested === null ? current : requested;
      let destination = origin + 1;
      while (destination < cards.length - 1 && targets[destination] <= targets[origin] + 2) destination++;
      goTo(destination);
    };
    const onKey = event => {
      if (event.target !== track || event.altKey || event.ctrlKey || event.metaKey) return;
      if (event.key === 'ArrowLeft') { event.preventDefault(); goPrevious(); }
      else if (event.key === 'ArrowRight') { event.preventDefault(); goNext(); }
      else if (event.key === 'Home') { event.preventDefault(); goTo(0); }
      else if (event.key === 'End') { event.preventDefault(); goTo(cards.length - 1); }
    };
    const onNativeGesture = () => {
      stopRotation();
      requested = null;
      manualAnnouncement = true;
      clearTimeout(settle);
    };
    const onPointerEnter = event => { if (event.pointerType !== 'touch') { hovered = true; syncRotation(); } };
    const onPointerLeave = event => { if (event.pointerType !== 'touch') { hovered = false; syncRotation(); } };
    const onFocusIn = () => { focused = true; stopRotation(); };
    const onFocusOut = event => { focused = section.contains(event.relatedTarget); syncRotation(); };
    const onRotationPointerDown = () => { pointerRotationIntent = rotationEnabled; };
    const onRotationPointerCancel = () => { pointerRotationIntent = null; };
    const toggleRotation = event => {
      const wasEnabled = event.detail > 0 && pointerRotationIntent !== null ? pointerRotationIntent : rotationEnabled;
      pointerRotationIntent = null;
      rotationEnabled = !wasEnabled && !motion.matches;
      syncRotation();
    };
    const onMotionChange = () => { if (motion.matches) rotationEnabled = false; syncRotation(); };
    const checkVisibility = () => {
      const rect = track.getBoundingClientRect();
      visible = rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
      syncRotation();
    };
    track.addEventListener('scroll', onScroll, {passive: true});
    track.addEventListener('keydown', onKey);
    track.addEventListener('pointerdown', onNativeGesture, {passive: true});
    track.addEventListener('wheel', onNativeGesture, {passive: true});
    previous.addEventListener('click', goPrevious);
    next.addEventListener('click', goNext);
    rotation.addEventListener('pointerdown', onRotationPointerDown);
    rotation.addEventListener('pointercancel', onRotationPointerCancel);
    rotation.addEventListener('click', toggleRotation);
    section.addEventListener('pointerenter', onPointerEnter);
    section.addEventListener('pointerleave', onPointerLeave);
    section.addEventListener('focusin', onFocusIn);
    section.addEventListener('focusout', onFocusOut);
    document.addEventListener('visibilitychange', syncRotation);
    if (motion.addEventListener) motion.addEventListener('change', onMotionChange);
    else motion.addListener(onMotionChange);
    let intersectionObserver = null;
    if (typeof IntersectionObserver !== 'undefined') {
      intersectionObserver = new IntersectionObserver(entries => {
        visible = entries.some(entry => entry.target === track && entry.isIntersecting && entry.intersectionRatio >= .2);
        syncRotation();
      }, {threshold: [0, .2]});
      intersectionObserver.observe(track);
    } else window.addEventListener('scroll', checkVisibility, {passive: true});
    let observer = null;
    if (typeof ResizeObserver !== 'undefined') {
      observer = new ResizeObserver(measure);
      observer.observe(track);
    }
    window.addEventListener('resize', measure);
    measure();
    opticianRailCleanup = () => {
      disposed = true;
      clearTimeout(settle);
      clearTimeout(rotationTimer);
      cancelAnimationFrame(frame);
      if (intersectionObserver) intersectionObserver.disconnect();
      else window.removeEventListener('scroll', checkVisibility);
      if (observer) observer.disconnect();
      window.removeEventListener('resize', measure);
      track.removeEventListener('scroll', onScroll);
      track.removeEventListener('keydown', onKey);
      track.removeEventListener('pointerdown', onNativeGesture);
      track.removeEventListener('wheel', onNativeGesture);
      previous.removeEventListener('click', goPrevious);
      next.removeEventListener('click', goNext);
      rotation.removeEventListener('pointerdown', onRotationPointerDown);
      rotation.removeEventListener('pointercancel', onRotationPointerCancel);
      rotation.removeEventListener('click', toggleRotation);
      section.removeEventListener('pointerenter', onPointerEnter);
      section.removeEventListener('pointerleave', onPointerLeave);
      section.removeEventListener('focusin', onFocusIn);
      section.removeEventListener('focusout', onFocusOut);
      document.removeEventListener('visibilitychange', syncRotation);
      if (motion.removeEventListener) motion.removeEventListener('change', onMotionChange);
      else motion.removeListener(onMotionChange);
    };
  }

  function init() { wireOpticianCarousel(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
